var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Address")]),_c('AddressCurrent',{attrs:{"form":_vm.form},model:{value:(_vm.form.current_address),callback:function ($$v) {_vm.$set(_vm.form, "current_address", $$v)},expression:"form.current_address"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }